"use client";
import Thumbnail from "@marginly/ui/components/thumbnail";
import T from "@marginly/ui/components/typography";
import { useRouter } from "next/navigation";
import React from "react";

import type { ChainSegmentParams, ParamProps } from "@/app/types";
import Space from "@/components/common/space";
import {
  ChainsTab,
  ChainsTabItem,
  OverflowContainer,
} from "@/components/common/tabs";
import { GlobalWrapper, Wrapper } from "@/components/common/wrapper.styled";
import Farm from "@/components/farm";
import { FarmTitle } from "@/components/farm/styled";

const networks = [
  {
    id: "arbitrum",
    label: "Arbitrum",
    image: "/images/network/arbitrum.svg",
  },
  {
    id: "mainnet",
    label: "Ethereum",
    image: "/images/network/ethereum.svg",
  },
  {
    id: "blast",
    label: "Blast",
    image: "/images/network/blast.svg",
  },
];

export default function FarmPage({ params }: ParamProps<ChainSegmentParams>) {
  const router = useRouter();

  return (
    <GlobalWrapper>
      <Wrapper>
        <FarmTitle>
          <T headerL>Farm</T>
          <Space height={6} heightMobile={6} />
          <T body secondary>
            High APYs with 10x leveraged strategies.
          </T>
        </FarmTitle>

        <OverflowContainer>
          <ChainsTab>
            {networks.map(({ id, label, image }) => {
              return (
                <ChainsTabItem
                  className={params.chain !== id ? "" : "active"}
                  onClick={() => router.push(`/${id}/farm`)}
                  key={id}
                >
                  <Thumbnail md rectangle>
                    <img
                      src={image}
                      alt={label}
                      style={{ filter: "invert(var(--svg-invert))" }}
                    />
                  </Thumbnail>
                  <div>{label}</div>
                </ChainsTabItem>
              );
            })}
          </ChainsTab>
        </OverflowContainer>

        <Space height={26} heightMobile={26} />

        <Farm chainName={params.chain} />
      </Wrapper>
      <Space height={48} heightMobile={74} />
    </GlobalWrapper>
  );
}
